import { tryCatchHelper } from '../../helpers';
import { uploadFilesService } from './FilesService';

export const USU_ENTIDADES_CONST = 'usuEntidades';

export const uploadFilesAction = async (
  { dispatch, notify },
  tipo,
  data,
  params,
) => {
  try {
    try {
      const res = await uploadFilesService(data);
      notify(res.data.message);

      // switch (tipo) {
      //   case USU_ENTIDADES_CONST:
      //     await allUsuEntidadesAction(dispatch, params);

      //     break;
      //   case USUARIOS_CONST:
      //     await allUsuariosAction(dispatch, params);

      //     break;

      //   default:
      //     break;
      // }
      return res.data;
    } catch (e) {
      tryCatchHelper({ e, notify });
      return false;
    }
  } catch (e) {
    console.log(e);
  }
};
